import { motion } from "framer-motion";

const EASE = [0.85, 0, 0.15, 1];

const CHAPTERS = [
  {
    number: "01",
    title: "A Origem",
    body: "Da lendária Rua 25 de Março — o coração comercial do Brasil — nasce uma nova coroa. Levamos para o digital a mesma abundância que faz milhões de pessoas atravessarem o país em busca da melhor mercadoria.",
  },
  {
    number: "02",
    title: "A Curadoria",
    body: "Nada entra no reino sem passar pelo crivo real. Bolsas, perfumes, acessórios, utensílios, ferramentas e personalização: cada item é escolhido para revender bem, encantar quem compra e valorizar quem vende.",
  },
  {
    number: "03",
    title: "O Reinado",
    body: "Luxo acessível não é contradição — é a nossa bandeira. Preço de 25 de Março, experiência de alta joalheria. Prepare-se: as portas do palácio estão prestes a se abrir.",
  },
];

export const ManifestoSection = () => (
  <section data-testid="manifesto-section" className="relative mx-auto max-w-7xl px-5 py-28 sm:px-8 sm:py-36">
    <motion.p
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1, ease: EASE }}
      className="mb-20 text-[11px] font-semibold uppercase tracking-[0.5em] text-royal"
    >
      Manifesto Real
    </motion.p>

    <div className="space-y-24 sm:space-y-32">
      {CHAPTERS.map((chapter, i) => (
        <motion.div
          key={chapter.number}
          data-testid={`manifesto-chapter-${chapter.number}`}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, delay: 0.1 * i, ease: EASE }}
          className="grid grid-cols-1 gap-6 md:grid-cols-12 md:gap-8"
        >
          <div className="md:col-span-4">
            <span className="outline-text font-serif text-8xl font-bold leading-none sm:text-9xl">
              {chapter.number}
            </span>
          </div>
          <div className="md:col-span-6 md:col-start-6">
            <h2 className="font-serif text-3xl tracking-tight text-white sm:text-4xl lg:text-5xl">
              {chapter.title}
              <span className="ml-3 inline-block h-2 w-2 rounded-full bg-royal align-middle" />
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-neutral-400 sm:text-lg">
              {chapter.body}
            </p>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);
